import React from "react";
import PropTypes from "prop-types";
import styles from "./Tabs.css";

const tabs = ({ tabClick }) => {
  const tabNames = [
    { name: "Profile", type: "profile", icon: "far fa-user" },
    { name: "Resume", type: "resume", icon: "far fa-file-alt" },
    { name: "Portfolio", type: "portfolio", icon: "fas fa-briefcase" },
    { name: "Contact", type: "contact", icon: "far fa-address-card" }
  ];

  const tabsComponent = tabNames.map(({ name, type, icon }, index) => (
    <div
      role="button"
      tabIndex={index}
      className={styles.Tab}
      key={type}
      onClick={() => tabClick(type)}
      onKeyDown={() => tabClick(type)}
    >
      <i className={icon} style={{ fontSize: "36px" }} />
      <p className={styles.TabText}>{name}</p>
    </div>
  ));

  return <div className={styles.Tabs}>{tabsComponent}</div>;
};

tabs.propTypes = {
  tabClick: PropTypes.func.isRequired
};

export default tabs;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Tabs/Tabs.js